module.exports = __webpack_public_path__ + "img/logo_black.6d42bde0.svg";